(() => {
  if (customElements.get('sunpura-compatibility-paths')) return;

  class SunpuraCompatibilityPaths extends HTMLElement {
    constructor() {
      super();
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.enterTimer = null;
      this.observer = null;
    }

    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-compat-tab]')];
      this.panels = [...this.querySelectorAll('[data-compat-panel]')];
      if (!this.tabs.length || !this.panels.length) return;

      this.motionEnabled = this.dataset.motion !== 'false' && !this.motionQuery.matches;
      const requested = this.dataset.initialPath;
      const initial = this.tabs.some((tab) => tab.dataset.compatTab === requested) ? requested : this.tabs[0].dataset.compatTab;

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.show(tab.dataset.compatTab, true));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });

      this.show(initial, false);
      this.initReveal();
    }

    disconnectedCallback() {
      if (this.enterTimer) window.clearTimeout(this.enterTimer);
      if (this.observer) this.observer.disconnect();
    }

    onKeydown(event, index) {
      let nextIndex = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (nextIndex === null) return;
      event.preventDefault();
      const nextTab = this.tabs[nextIndex];
      this.show(nextTab.dataset.compatTab, true);
      nextTab.focus();
    }

    show(path, animate) {
      this.tabs.forEach((tab) => {
        const active = tab.dataset.compatTab === path;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        const active = panel.dataset.compatPanel === path;
        panel.hidden = !active;
        panel.classList.remove('is-entering');
        if (active && animate && this.motionEnabled) {
          requestAnimationFrame(() => panel.classList.add('is-entering'));
          if (this.enterTimer) window.clearTimeout(this.enterTimer);
          this.enterTimer = window.setTimeout(() => panel.classList.remove('is-entering'), 760);
        }
      });
    }

    initReveal() {
      if (!this.motionEnabled || !('IntersectionObserver' in window)) {
        this.classList.add('is-revealed');
        return;
      }
      this.observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.classList.add('is-revealed');
        this.observer.disconnect();
      }, { threshold: 0.18 });
      this.observer.observe(this);
    }
  }

  customElements.define('sunpura-compatibility-paths', SunpuraCompatibilityPaths);
})();
